import { useCookiesStore } from '@/store/cookies';

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
        dataLayer?: any[];
    }
}

export function useGoogleAnalytics() {
    const cookiesStore = useCookiesStore();
    const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';

    function loadGoogleAnalytics() {
        if (!GA_MEASUREMENT_ID || !cookiesStore.isAnalyticsEnabled) {
            return;
        }

        // Prevent double loading
        if (window.gtag) {
            return;
        }

        // Initialize dataLayer
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
            window.dataLayer!.push(args);
        }
        window.gtag = gtag;

        // Load Google Analytics script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);

        // Configure gtag (matching the original setup)
        window.gtag('js', new Date());
        window.gtag('config', GA_MEASUREMENT_ID);
    }

    function initialize() {
        if (cookiesStore.hasConsent === null) {
            // Consent not yet given, wait for user decision
            return;
        }

        if (cookiesStore.isAnalyticsEnabled) {
            loadGoogleAnalytics();
        }
    }

    function trackEvent(action: string, category: string, label?: string, value?: number) {
        if (!cookiesStore.isAnalyticsEnabled || !window.gtag) {
            return;
        }

        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value,
        });
    }

    function trackPageView(path: string) {
        if (!cookiesStore.isAnalyticsEnabled || !window.gtag) {
            return;
        }

        window.gtag('config', GA_MEASUREMENT_ID, {
            page_path: path,
        });
    }

    return {
        loadGoogleAnalytics,
        initialize,
        trackEvent,
        trackPageView,
    };
}

